import type { SolidWallSide } from "building-types/walls/wallTypes";
import { windowDescriptorShouldCutWall } from "../window/windowQuery";

export function* iterableSolidWallSideOpenings(side: SolidWallSide) {
  for (const window of side.windows) {
    if (window.opening && windowDescriptorShouldCutWall(window)) {
      yield window;
    }
  }
  for (const door of side.doors) {
    if (door.opening) {
      yield door;
    }
  }
  for (const wallCut of side.wallCuts) {
    if (wallCut.opening) {
      yield wallCut;
    }
  }
}
